import styled from "styled-components";

const Messages = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default Messages;
